/*
* Companies Search for autocomplete search. Requires jQuery-UI Autocomplete
*/
var VendorsSearch = {
    companySearchTimer: '',
    /*
     * @param object params - Can contain next parameters:
     *      @param string inputSelector - Search input selector (e.g. #search-input, .search-input)
     *      @param string companyIdInpSelector - Selector of input for chosen company ID
     *      @param string resultsHolderClass - Search results holder/container additional class
     *      @param string searchResultsClass - Single search result holder class
     *      @param string appendToSelector - Which element the menu should be appended to
     *      @param string loaderSelector - Selector of loader element (hide/show on results loading)
     *      @param function selectFunction - Select function for autocomplete (function (event, ui){...})
     *      @param boolean autoSelect - If company name typed correctly - Select Function will be called automatically
     *      @param function getRequestParams - Function to get the additional request parameters. Must return parameters object
     *      @param function customOutput - Function for custom html output
     *      @param boolean moreResultsLink - More results link visibility
     *      @param number resultLimit - Result quantity
     *
     * Has custom event - 'VendorsSearch:response', fired on input
     */
    init: function (params) {
        var ajaxUrl = typeof ajaxUrl_ht !== 'undefined' ? ajaxUrl_ht : ajaxurl;

        if (params.searchResultsClass === undefined) {
            params.searchResultsClass = "company-search-choice";
        }


        if (typeof params.inputSelector !== 'undefined' &&
            jQuery(params.inputSelector).length > 0 &&
            typeof ajaxUrl !== 'undefined' && (
                (
                    typeof (params.companyIdInpSelector) !== 'undefined' &&
                    jQuery(params.companyIdInpSelector).length > 0
                ) || typeof params.selectFunction !== 'undefined'
            )
        ) {

            if (params.selectFunction === undefined) {
                params.selectFunction = function (event, ui) {
                    jQuery(params.companyIdInpSelector).val(ui.item.post_id)
                };
            }

            //autocomplete options
            var options = {
                //post ajax
                source: function (request, response) {

                    request['action'] = 'vendors_search';
                    if (params.resultLimit !== undefined) {
                        request['limit'] = params.resultLimit;
                    }
                    if (params.getRequestParams !== undefined) {
                        var requestParams = params.getRequestParams();
                        for (var key in requestParams) {
                            request[key] = requestParams[key];
                        }
                    }
                    jQuery.post(ajaxUrl, request, function (data) {
                        response(data);
                    });
                },
                create: function () {
                    jQuery(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        //render item
                        if (params.resultsHolderClass !== undefined) {
                            ul.addClass(params.resultsHolderClass);
                        } else {
                            ul.addClass('vendors-search-results-holder');
                        }
                        var $html = item.label;

                        //custom output
                        if (params.customOutput !== undefined) {
                            $html = params.customOutput(ul, item)
                        }
                        return jQuery("<li>")
                            .attr({
                                "class": params.searchResultsClass,
                                "data-company-id": item.post_id
                            })
                            .html($html)
                            .appendTo(ul);
                    };
                },
                response: function (event, ui) {
                    if (typeof params.autoSelect !== 'undefined' && params.autoSelect === true) {
                        var search = jQuery(this).val(),
                            data = ui.content;
                        jQuery.each(data, function (i, v) {
                            if (v.label.toLowerCase() == search.toLowerCase()) {
                                //imitate select
                                params.selectFunction(event, {item: v});
                            }
                        });
                    }

                    jQuery(this).trigger('VendorsSearch:response', []);
                },
                autoFocus: true,
                minLength: 0,
                select: params.selectFunction,
            };

            if (params.appendToSelector !== undefined && jQuery(params.appendToSelector).length) {
                options.appendTo = params.appendToSelector;
            }

            if (params.loaderSelector !== undefined && jQuery(params.loaderSelector).length) {
                options.search = function (event, ui) {
                    jQuery(params.loaderSelector).show();
                };
                options.open = function (event, ui) {
                    jQuery(params.loaderSelector).hide();
                };
            }

            //init autocomplete
            jQuery(params.inputSelector).autocomplete(options);
        }
    }
};